/*
 * @Description:
 * @Author: fiveonelei
 * @Date: 2022-02-11 10:11:35
 * @FilePath: /app-monorepo-projects/packages/app-share/src/constants/video.ts
 */

export const NETWORKTYPE = {
  1: 'wifi',
  2: '2g',
  3: '3g',
  4: '4g',
  8: 'wifi',
};

export const SPEC_MAP = {
  f0: 0, // f0 原始档位
  f10: 1, // f10 码率256kbps，分辨率宽度320（可能调整）
  f20: 2, // f20 码率512kbps，分辨率宽度640（可能调整）
  f720: 7, // f20+水印
  f30: 8, // f30 码率2500kbps，原始宽高
  f40: 10, // 丽影转码
  f730: 11, // f30+水印
  f9600: 13, // f30+关键帧
  f740: 14, // f30+红包水印
  f9720: 15, // f20+水印+关键帧
  f9730: 16, // f30+水印+关键帧
  f60: 25, // f60高清档位
  rec: 999, // 后台推荐档位
  f70: 27, // 新极速高清-所有视频
  f9670: 29, // 新极速高清-AB互动视频
};

export const STATE_START_PLAY = 'start_play';
export const STATE_PAUSED = 'paused';
export const DEFAULT_OPTIONS = {
  controls: false, // 是否显示控制条
  preload: 'auto',
  fill: true,
  errorDisplay: false,
};

export type SpecMapType = keyof typeof SPEC_MAP;

// 音频事件枚举
export enum EVideoEvtNameTypes {
  readyPlay = 'readyPlay', // 准备播放
  play = 'play',    // 播放
  pause = 'pause',  // 暂停
  stop = 'stop',    // 停止
  changePlayOrPause = 'changePlayOrPause', // 播放和暂停之间的切换
  change = 'change',    // 音频状态改变
}
